// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__fGi5D","name":"styles_name__BUk-6","subtitle":"styles_subtitle__FCZmW","date":"styles_date__hrWcT"};